const reducerName = '@cityoo-backoffice/spatial/logs';

export const RESET = `${reducerName}/RESET`;

export const GET_ACTIVITY_LOGS_START = `${reducerName}/GET_ACTIVITY_LOGS_START`;
export const GET_ACTIVITY_LOGS_SUCCESS = `${reducerName}/GET_ACTIVITY_LOGS_SUCCESS`;
export const GET_ACTIVITY_LOGS_FAIL = `${reducerName}/GET_ACTIVITY_LOGS_FAIL`;

export const SET_CURRENT_PAGE = `${reducerName}/SET_CURRENT_PAGE`;
